module.exports = __webpack_public_path__ + "static/media/assembly5.86dafd64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/assembly5.png
// module id = 2423
// module chunks = 0